<template>
  <div>
    <head>
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar />

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">PHARMACY</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('hospital-dashboard')">Hospital</a></li>
                      <li class="breadcrumb-item active">Pharmacy</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stats Cards -->
            <div class="row">
              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" :class="{'active': activeTab === 'pending'}" @click="activeTab = 'pending'">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Pending</p>
                        <h4 class="mb-0">{{ stats.pending || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-warning">
                        <span class="avatar-title bg-transparent text-warning">
                          <i class="mdi mdi-clock-outline font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" :class="{'active': activeTab === 'partial'}" @click="activeTab = 'partial'">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Partial</p>
                        <h4 class="mb-0">{{ stats.partial || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-info">
                        <span class="avatar-title bg-transparent text-info">
                          <i class="mdi mdi-pill font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" :class="{'active': activeTab === 'completed'}" @click="activeTab = 'completed'">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Dispensed Today</p>
                        <h4 class="mb-0">{{ stats.completed || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-success">
                        <span class="avatar-title bg-transparent text-success">
                          <i class="mdi mdi-check-circle font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card card-stat" @click="goTo('pharmacy-inventory')">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Low Stock Alert</p>
                        <h4 class="mb-0">{{ stats.lowStock || 0 }}</h4>
                      </div>
                      <div class="avatar-md rounded-circle bg-soft-danger">
                        <span class="avatar-title bg-transparent text-danger">
                          <i class="mdi mdi-alert font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Content Card -->
            <div class="card">
              <div class="card-body">
                <!-- Header with Filters -->
                <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
                  <div>
                    <h5 class="mb-1"><i class="mdi mdi-prescription me-2 text-primary"></i>Prescription Queue</h5>
                    <p class="text-muted mb-0">Manage prescriptions and dispensing</p>
                  </div>
                  <div class="d-flex gap-2">
                    <input type="date" class="form-control" v-model="dateFrom" @change="loadPrescriptions" style="width: 140px;">
                    <input type="date" class="form-control" v-model="dateTo" @change="loadPrescriptions" style="width: 140px;">
                    <button class="btn btn-soft-primary" @click="loadPrescriptions">
                      <i class="mdi mdi-refresh"></i> Refresh
                    </button>
                  </div>
                </div>

                <!-- Tabs -->
                <ul class="nav nav-tabs nav-tabs-custom mb-4">
                  <li class="nav-item">
                    <a class="nav-link" :class="{'active': activeTab === 'pending'}" href="javascript:void(0);" @click="activeTab = 'pending'">
                      Pending <span class="badge bg-warning ms-1">{{ stats.pending || 0 }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{'active': activeTab === 'partial'}" href="javascript:void(0);" @click="activeTab = 'partial'">
                      Partial <span class="badge bg-info ms-1">{{ stats.partial || 0 }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{'active': activeTab === 'completed'}" href="javascript:void(0);" @click="activeTab = 'completed'">
                      Dispensed <span class="badge bg-success ms-1">{{ stats.completed || 0 }}</span>
                    </a>
                  </li>
                </ul>

                <!-- Loading -->
                <div v-if="loading" class="text-center py-5">
                  <div class="spinner-border text-primary mb-3"></div>
                  <p class="text-muted mb-0">Loading prescriptions...</p>
                </div>

                <!-- Prescriptions Table -->
                <div v-else-if="filteredPrescriptions.length > 0" class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="table-light">
                    <tr>
                      <th>Rx ID</th>
                      <th>Patient</th>
                      <th>Diagnosis</th>
                      <th>Items</th>
                      <th>Prescriber</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th style="width: 150px;">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="rx in filteredPrescriptions" :key="rx.prescriptionID">
                      <td>
                        <span class="fw-medium text-primary">{{ rx.prescriptionID }}</span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="avatar-sm me-2">
                              <span class="avatar-title rounded-circle" :class="rx.patientGender === 'Male' ? 'bg-primary' : 'bg-pink'">
                                {{ getInitials(rx.patientName) }}
                              </span>
                          </div>
                          <div>
                            <h6 class="mb-0">{{ rx.patientName }}</h6>
                            <small class="text-muted">{{ rx.patientAge }} yrs</small>
                          </div>
                        </div>
                      </td>
                      <td>
                          <span class="text-truncate d-inline-block" style="max-width: 150px;" :title="rx.diagnosis">
                            {{ rx.diagnosis || '-' }}
                          </span>
                      </td>
                      <td>
                        <span class="badge bg-light text-dark">{{ rx.totalItems }} item(s)</span>
                      </td>
                      <td>
                        <small>{{ rx.prescriberName }}</small>
                      </td>
                      <td>
                        <small>{{ formatDateTime(rx.prescriptionDate || rx.dateCreated) }}</small>
                      </td>
                      <td>
                        <span class="badge" :class="getStatusBadge(rx.status)">{{ rx.status }}</span>
                      </td>
                      <td>
                        <div class="d-flex gap-1">
                          <!-- Pending/Active: Dispense -->
                          <button v-if="rx.status === 'Active' || rx.status === 'Pending'"
                                  class="btn btn-sm btn-soft-primary"
                                  @click="goToDispensing(rx)"
                                  title="Dispense">
                            <i class="mdi mdi-pill"></i> Dispense
                          </button>

                          <!-- View Details -->
                          <button class="btn btn-sm btn-soft-secondary"
                                  @click="viewPrescription(rx)"
                                  title="View Details">
                            <i class="mdi mdi-eye"></i>
                          </button>

                          <!-- Print -->
                          <button class="btn btn-sm btn-soft-info"
                                  @click="printPrescription(rx)"
                                  title="Print">
                            <i class="mdi mdi-printer"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Empty State -->
                <div v-else class="text-center py-5">
                  <div class="empty-state-icon mb-3">
                    <i class="mdi mdi-pill"></i>
                  </div>
                  <h5 class="mb-2">No prescriptions found</h5>
                  <p class="text-muted mb-0">There are no {{ activeTab }} prescriptions for the selected date range.</p>
                </div>

              </div>
            </div>

          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">County Hospital Management System</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <!-- View Prescription Modal -->
    <div class="modal fade" id="viewPrescriptionModal" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="mdi mdi-prescription me-2"></i>Prescription Details</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body" v-if="selectedPrescription">
            <!-- Patient Info -->
            <div class="row mb-3">
              <div class="col-md-6">
                <small class="text-muted">Patient</small>
                <h6 class="mb-0">{{ selectedPrescription.patientName }}</h6>
              </div>
              <div class="col-md-3">
                <small class="text-muted">Age</small>
                <h6 class="mb-0">{{ selectedPrescription.patientAge }} years</h6>
              </div>
              <div class="col-md-3">
                <small class="text-muted">Weight</small>
                <h6 class="mb-0">{{ selectedPrescription.patientWeight || '-' }} kg</h6>
              </div>
            </div>

            <!-- Diagnosis & Allergies -->
            <div class="row mb-3">
              <div class="col-md-8">
                <small class="text-muted">Diagnosis</small>
                <p class="mb-0">{{ selectedPrescription.diagnosis || '-' }}</p>
              </div>
              <div class="col-md-4">
                <small class="text-muted">Allergies</small>
                <p class="mb-0 text-danger">{{ selectedPrescription.allergies || 'None reported' }}</p>
              </div>
            </div>

            <!-- Prescription Items -->
            <h6 class="mb-2 mt-4">Medications</h6>
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead class="table-light">
                <tr>
                  <th>#</th>
                  <th>Drug</th>
                  <th>Dosage</th>
                  <th>Frequency</th>
                  <th>Duration</th>
                  <th>Qty</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="prescriptionItems.length === 0">
                  <td colspan="7" class="text-center text-muted py-3">
                    <i class="mdi mdi-pill-off me-1"></i> No medications found
                  </td>
                </tr>
                <tr v-for="(item, index) in prescriptionItems" :key="item.itemID">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <strong>{{ item.drugName }}</strong>
                    <small class="text-muted d-block">{{ item.genericName }} {{ item.strength }}</small>
                  </td>
                  <td>{{ item.dosage }}</td>
                  <td>{{ item.frequency }} <small v-if="item.frequencyDetails" class="text-muted">({{ item.frequencyDetails }})</small></td>
                  <td>{{ item.duration || (item.durationDays + ' days') }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>
                      <span class="badge" :class="item.status === 'Dispensed' ? 'bg-success' : (item.status === 'Partial' ? 'bg-info' : 'bg-warning')">
                        {{ item.status }}
                      </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <!-- Notes -->
            <div v-if="selectedPrescription.prescriptionNotes" class="mt-3">
              <small class="text-muted">Notes</small>
              <p class="mb-0">{{ selectedPrescription.prescriptionNotes }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
            <button v-if="selectedPrescription && (selectedPrescription.status === 'Active' || selectedPrescription.status === 'Pending')"
                    type="button" class="btn btn-primary" @click="goToDispensingFromModal">
              <i class="mdi mdi-pill me-1"></i> Dispense
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast Notification -->
    <ToastNotification ref="toast" />
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToastNotification from "@/components/hospital/ToastNotification.vue";
import { execute, hospital } from "@/api";

export default {
  name: "PharmacyDashboard",
  components: { NavigationBar, ToastNotification },
  data() {
    return {
      loading: true,
      activeTab: 'pending',

      // Date filters
      dateFrom: new Date().toISOString().split('T')[0],
      dateTo: new Date().toISOString().split('T')[0],

      // Data
      prescriptions: [],
      prescriptionItems: [],
      stats: {
        pending: 0,
        partial: 0,
        completed: 0,
        lowStock: 0
      },

      // Selected prescription for modal
      selectedPrescription: null,

      // Session
      facilityID: '',
      facilityName: '',
      sessionNames: '',
      sessionIdNo: ''
    };
  },
  computed: {
    filteredPrescriptions() {
      if (!this.prescriptions || this.prescriptions.length === 0) return [];

      switch (this.activeTab) {
        case 'pending':
          return this.prescriptions.filter(rx => rx.status === 'Active' || rx.status === 'Pending');
        case 'partial':
          return this.prescriptions.filter(rx => rx.status === 'Partial');
        case 'completed':
          return this.prescriptions.filter(rx => rx.status === 'Dispensed');
        default:
          return this.prescriptions;
      }
    }
  },
  methods: {
    goTo(route) {
      this.$router.push('/' + route);
    },

    showSuccess(message) {
      if (this.$refs.toast) {
        this.$refs.toast.success(message);
      } else {
        console.log('Success:', message);
      }
    },

    showError(message) {
      if (this.$refs.toast) {
        this.$refs.toast.error(message);
      } else {
        console.error('Error:', message);
        alert(message);
      }
    },

    getInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    },

    formatDateTime(date) {
      if (!date) return '-';
      return new Date(date).toLocaleString('en-GB', {
        day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit'
      });
    },

    getStatusBadge(status) {
      switch (status) {
        case 'Active':
        case 'Pending': return 'bg-warning text-dark';
        case 'Processing':
        case 'Partial': return 'bg-info';
        case 'Dispensed': return 'bg-success';
        case 'Cancelled': return 'bg-danger';
        default: return 'bg-secondary';
      }
    },

    loadPrescriptions() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getPharmacyQueue");
      data.append("facilityID", this.facilityID);

      execute(data, hospital)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.prescriptions = res.data.data.prescriptions || [];
              // Use stats from API if available, otherwise calculate locally
              if (res.data.data.stats) {
                this.stats = {
                  pending: res.data.data.stats.pending || 0,
                  partial: res.data.data.stats.partial || 0,
                  completed: res.data.data.stats.completed || 0,
                  lowStock: this.stats.lowStock || 0
                };
              } else {
                this.calculateStats();
              }
            } else {
              this.prescriptions = [];
              this.calculateStats();
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
            this.prescriptions = [];
          });
    },

    calculateStats() {
      this.stats = {
        pending: this.prescriptions.filter(rx => rx.status === 'Active' || rx.status === 'Pending').length,
        partial: this.prescriptions.filter(rx => rx.status === 'Partial').length,
        completed: this.prescriptions.filter(rx => rx.status === 'Dispensed').length,
        lowStock: this.stats.lowStock || 0
      };
    },

    loadLowStockAlerts() {
      const data = new FormData();
      data.append("function", "getLowStockAlerts");
      data.append("facilityID", this.facilityID);

      execute(data, hospital)
          .then((res) => {
            if (res.data.success) {
              this.stats.lowStock = (res.data.data.lowStockItems || []).length;
            }
          })
          .catch((e) => console.error(e));
    },

    goToDispensing(rx) {
      this.$router.push('/dispensing/' + rx.prescriptionID);
    },

    goToDispensingFromModal() {
      if (this.selectedPrescription) {
        bootstrap.Modal.getInstance(document.getElementById('viewPrescriptionModal')).hide();
        this.$router.push('/dispensing/' + this.selectedPrescription.prescriptionID);
      }
    },

    viewPrescription(rx) {
      this.selectedPrescription = rx;
      this.prescriptionItems = []; // Clear previous items
      this.loadPrescriptionItems(rx.prescriptionID);
      const modal = new bootstrap.Modal(document.getElementById('viewPrescriptionModal'));
      modal.show();
    },

    loadPrescriptionItems(prescriptionID) {
      const data = new FormData();
      data.append("function", "getPrescription");
      data.append("prescriptionID", prescriptionID);

      execute(data, hospital)
          .then((res) => {
            if (res.data.success) {
              // getPrescription returns both prescription and items
              this.prescriptionItems = res.data.data.items || [];
              // Also update selected prescription with full details
              if (res.data.data.prescription) {
                this.selectedPrescription = { ...this.selectedPrescription, ...res.data.data.prescription };
              }
            }
          })
          .catch((e) => console.error(e));
    },

    printPrescription(rx) {
      const printContent = `
        <html>
        <head>
          <title>Prescription - ${rx.prescriptionID}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; font-size: 14px; }
            .header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 20px; }
            .header h2 { margin: 0; }
            .rx-symbol { font-size: 24px; font-weight: bold; }
            .patient-info { margin-bottom: 20px; }
            .patient-info table { width: 100%; }
            .patient-info td { padding: 5px 0; }
            .medications { margin-top: 20px; }
            .medications table { width: 100%; border-collapse: collapse; }
            .medications th, .medications td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            .medications th { background: #f5f5f5; }
            .footer { margin-top: 40px; border-top: 1px solid #ddd; padding-top: 20px; }
            .signature { margin-top: 40px; }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>${this.facilityName}</h2>
            <p>Prescription</p>
          </div>

          <div class="patient-info">
            <table>
              <tr>
                <td><strong>Patient:</strong> ${rx.patientName}</td>
                <td><strong>Age:</strong> ${rx.patientAge} years</td>
                <td><strong>Date:</strong> ${this.formatDateTime(rx.prescriptionDate)}</td>
              </tr>
              <tr>
                <td colspan="3"><strong>Diagnosis:</strong> ${rx.diagnosis || '-'}</td>
              </tr>
              <tr>
                <td colspan="3"><strong>Allergies:</strong> ${rx.allergies || 'None reported'}</td>
              </tr>
            </table>
          </div>

          <div class="rx-symbol">℞</div>

          <div class="footer">
            <p><strong>Prescriber:</strong> ${rx.prescriberName}</p>
            <div class="signature">
              <p>_________________________</p>
              <p>Signature</p>
            </div>
          </div>
        </body>
        </html>
      `;
      const printWindow = window.open('', '_blank');
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    }
  },
  mounted() {
    this.facilityID = sessionStorage.getItem("hospitalFacilityID") || '';
    this.facilityName = sessionStorage.getItem("hospitalFacilityName") || '';
    this.sessionNames = sessionStorage.getItem("sessionNames") || '';
    this.sessionIdNo = sessionStorage.getItem("sessionIdNo") || '';

    this.loadPrescriptions();
    this.loadLowStockAlerts();
  }
};
</script>

<style scoped>
.avatar-sm { width: 2.25rem; height: 2.25rem; }
.avatar-md { width: 3rem; height: 3rem; }
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
  color: #fff;
  font-size: 0.75rem;
}

.bg-pink { background-color: #e83e8c !important; }
.bg-soft-warning { background-color: rgba(255, 193, 7, 0.15) !important; }
.bg-soft-info { background-color: rgba(23, 162, 184, 0.15) !important; }
.bg-soft-primary { background-color: rgba(85, 110, 230, 0.15) !important; }
.bg-soft-success { background-color: rgba(52, 195, 143, 0.15) !important; }
.bg-soft-danger { background-color: rgba(244, 106, 106, 0.15) !important; }
.bg-soft-secondary { background-color: rgba(116, 120, 141, 0.15) !important; }

.card-stat {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.card-stat:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.card-stat.active {
  border-color: #556ee6;
  background: linear-gradient(135deg, #f8f9ff 0%, #fff 100%);
}

.empty-state-icon {
  width: 80px;
  height: 80px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.empty-state-icon i {
  font-size: 40px;
  color: #adb5bd;
}

.card {
  border: none;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.table > :not(caption) > * > * {
  padding: 0.75rem;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

.nav-tabs-custom .nav-link {
  border: none;
  color: #74788d;
  padding: 0.5rem 1rem;
}

.nav-tabs-custom .nav-link.active {
  color: #556ee6;
  border-bottom: 2px solid #556ee6;
  background: transparent;
}

.btn-soft-info { background-color: rgba(23, 162, 184, 0.15); color: #17a2b8; }
.btn-soft-info:hover { background-color: #17a2b8; color: #fff; }

.btn-soft-primary { background-color: rgba(85, 110, 230, 0.15); color: #556ee6; }
.btn-soft-primary:hover { background-color: #556ee6; color: #fff; }

.btn-soft-success { background-color: rgba(52, 195, 143, 0.15); color: #34c38f; }
.btn-soft-success:hover { background-color: #34c38f; color: #fff; }

.btn-soft-secondary { background-color: rgba(116, 120, 141, 0.15); color: #74788d; }
.btn-soft-secondary:hover { background-color: #74788d; color: #fff; }
</style>